/* eslint-disable no-shadow */
import { Form } from 'react-bootstrap';
import Checkbox from 'components/global/Field/FieldComponents/Checkbox';
import CheckboxGroup from 'components/global/Field/FieldComponents/CheckboxGroup';
import Currency from 'components/global/Field/FieldComponents/Currency';
import CurrencyDecimal from 'components/global/Field/FieldComponents/CurrencyDecimal';
import Country from 'components/global/Field/FieldComponents/Country';
import TextInput from 'components/global/Field/FieldComponents/TextInput';
import TextPassword from 'components/global/Field/FieldComponents/TextPassword';
import DateSelect from 'components/global/Field/FieldComponents/DateSelect';
import Email from 'components/global/Field/FieldComponents/Email';
import Ein from 'components/global/Field/FieldComponents/Ein';
import Integer from 'components/global/Field/FieldComponents/Integer';
import Percent from 'components/global/Field/FieldComponents/Percent';
import Phone from 'components/global/Field/FieldComponents/Phone';
import MultiSelect from 'components/global/Field/FieldComponents/MultiSelect';
import State from 'components/global/Field/FieldComponents/State';
import TextArea from 'components/global/Field/FieldComponents/TextArea';
import ToggleSwitch from 'components/global/Field/FieldComponents/ToggleSwitch';
import Radio from 'components/global/Field/FieldComponents/Radio';
import Select from 'components/global/Field/FieldComponents/Select';
import YesNo from 'components/global/Field/FieldComponents/YesNo';
import Zip from 'components/global/Field/FieldComponents/Zip';

const Field = ({
  type,
  name,
  label,
  onChange,
  onBlur,
  onKeyUp,
  className,
  disabled,
  labelClassName,
  inputClassName,
  evenRowClassName,
  options,
  value = '',
  selectedClass = '',
  countryValue = null,
  placeholder,
  checkboxClassName,
  checkboxLabelClassName,
  dropDownClassName,
  style,
  password,
  selectedVariant,
  unselectedVariant,
  required = false,
  id,
  xs,
  sm,
  md,
  lg,
  xl,
  xxl,
  xxxl,
  min,
  max,
}) => {
  const commonProps = {
    type,
    name,
    label,
    className,
    labelClassName,
    inputClassName,
  };
  const handleInputChange = (e) => {
    if (e.target.value === 'true') {
      onChange({ name: e.target.name, value: true });
    } else if (e.target.value === 'false') {
      onChange({ name: e.target.name, value: false });
    } else {
      onChange({ name: e.target.name, value: e.target.value });
    }
  };

  const handleSelectChange = ({ name, value }) => {
    onChange({ name, value });
  };

  const ComponentMap = {
    checkbox: <Checkbox {...commonProps} value={value} checkboxClassName={checkboxClassName} onChange={handleSelectChange} disabled={disabled} />,
    'checkbox-group': <CheckboxGroup
      {...commonProps}
      onChange={handleSelectChange}
      options={options}
      value={value}
      evenRowClassName={evenRowClassName}
      labelClassName={labelClassName}
      checkboxClassName={checkboxClassName}
      checkboxLabelClassName={checkboxLabelClassName}
      xs={xs}
      sm={sm}
      md={md}
      lg={lg}
      xl={xl}
      xxl={xxl}
      xxxl={xxxl}
    />,
    country: <Country {...commonProps} required={required} onChange={handleSelectChange} value={value} />,
    currency: <Currency {...commonProps} onChange={handleInputChange} value={value} placeholder={placeholder} />,
    'currency-decimal': <CurrencyDecimal {...commonProps} onChange={handleInputChange} value={value} placeholder={placeholder} />,
    date: <DateSelect {...commonProps} onChange={handleSelectChange} value={value} />,
    ein: <Ein {...commonProps} onChange={handleInputChange} value={value} placeholder={placeholder} />,
    email: <Email {...commonProps} onChange={handleInputChange} value={value} placeholder={placeholder} />,
    integer: <Integer
      {...commonProps}
      onChange={handleInputChange}
      value={value}
      placeholder={placeholder}
      onBlur={onBlur}
      onKeyUp={onKeyUp}
      style={style}
      min={min}
      max={max}
    />,
    'multi-select': <MultiSelect
      {...commonProps}
      onChange={handleSelectChange}
      options={options}
      value={value || []}
      selectedClass={selectedClass}
      selectedVariant={selectedVariant || 'primary'}
      unselectedVariant={unselectedVariant || 'outline-primary'}
    />,
    percent: <Percent {...commonProps} onChange={handleInputChange} value={value} placeholder={placeholder} />,
    phone: <Phone {...commonProps} onChange={handleInputChange} value={value} placeholder={placeholder} required={required} />,
    radio: <Radio {...commonProps} onChange={handleInputChange} options={options} value={value} />,
    select: <Select
      {...commonProps}
      onChange={handleInputChange}
      options={options}
      value={value}
      dropDownClassName={dropDownClassName}
      placeholder={placeholder}
    />,
    state: <State {...commonProps} required={required} onChange={onChange} value={value} countryValue={countryValue} />,
    'text-area': <TextArea {...commonProps} onChange={handleInputChange} value={value} placeholder={placeholder} style={style} />,
    'text-password': <TextPassword {...commonProps} onChange={handleInputChange} value={value} placeholder={placeholder} />,
    'text-input': <TextInput
      {...commonProps}
      disabled={disabled}
      required={required}
      inputClassName={inputClassName}
      onChange={handleInputChange}
      value={value}
      placeholder={placeholder}
      password={password}
    />,
    'toggle-switch': <ToggleSwitch {...commonProps} onChange={handleSelectChange} options={options} value={value} id={id} />,
    'yes-no': <YesNo {...commonProps} onChange={onChange} options={options} value={value} />,
    zip: <Zip {...commonProps} required={required} onChange={handleInputChange} value={value} placeholder={placeholder} />,
  };
  if (!ComponentMap[type]) {
    <Form.Label>{label}</Form.Label>;
  }

  const Component = ComponentMap[type];
  return Component;
};

export default Field;
